import * as yup from "yup";
import { TFunction } from "i18next";

const numberPattern = /^\d+(\.\d{1,2})?$/;

export const getBaseTariffFormValidation = (t: TFunction) => {
  const percentField = yup
    .string()
    .required(t("validation.required"))
    .matches(numberPattern, t("directory.baseTariffs.modal.numberFormat"))
    .test(
      "max-percent",
      t("directory.baseTariffs.modal.maxPercent"),
      (value) => value === undefined || Number(value) <= 100,
    );

  const amountField = yup.string().matches(numberPattern, {
    excludeEmptyString: true,
    message: t("directory.baseTariffs.modal.numberFormat"),
  });

  return yup.object().shape({
    price: yup.string().when(["dealerDiscounts", "employeeDiscounts"], {
      is: (dealerDiscounts: unknown[], employeeDiscounts: unknown[]) =>
        (dealerDiscounts?.length ?? 0) > 0 ||
        (employeeDiscounts?.length ?? 0) > 0,
      then: yup
        .string()
        .required(t("directory.baseTariffs.modal.priceRequired"))
        .matches(numberPattern, t("directory.baseTariffs.modal.numberFormat"))
        .test(
          "positive-price",
          t("directory.baseTariffs.modal.priceRequired"),
          (value) => {
            if (value === undefined || value === "") {
              return false;
            }
            const parsed = Number(value);
            return Number.isFinite(parsed) && parsed > 0;
          },
        ),
      otherwise: yup.string().matches(numberPattern, {
        excludeEmptyString: true,
        message: t("directory.baseTariffs.modal.numberFormat"),
      }),
    }),
    dealerDiscounts: yup
      .array()
      .default([])
      .of(
        yup.object().shape({
          dealers: yup.array().min(1, t("validation.required")),
          percent: percentField,
          amount: amountField,
          priceWithDiscount: yup.string(),
        }),
      ),
    employeeDiscounts: yup
      .array()
      .default([])
      .of(
        yup.object().shape({
          dealer: yup.object().required(t("validation.required")).nullable(),
          employee: yup.object().required(t("validation.required")).nullable(),
          percent: percentField,
          amount: amountField,
          priceWithDiscount: yup.string(),
        }),
      ),
  });
};
